import { Component, OnInit ,ChangeDetectorRef} from '@angular/core';
//Enrutamiento
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
//Alertas
import swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
//Formularios
import { NgForm } from '@angular/forms';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
//Ventana Modal
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
//Datatable
import { OrderPipe } from 'ngx-order-pipe';
//Datalist
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';
//Servicios
import { DatatablesService } from '../../../servicios/datatable/datatables.service';
import { ConfigService } from '../../../servicios/config/config.service';
import { ValidService } from '../../../servicios/valid.service';
import { KeyService } from '../../../servicios/key.service';
import { PqrService } from '../../../servicios/pqr/pqr.service';
import { TercerosService } from '../../../servicios/terceros/terceros.service';
import { SucursalService } from '../../../servicios/Terceros/sucursal.service';
import { EquiposService } from '../../../servicios/equipos/equipos.service';
import { EquipoTerceroService } from '../../../servicios/equipos/equipo-tercero.service';
import { TiposervicioService } from '../../../servicios/pqr/tiposervicio.service';
import { TipopqrService     } from '../../../servicios/pqr/tipopqr.service';
import { MediosoporteService } from '../../../servicios/pqr/mediosoporte.service';
import { TratamientopqrService } from '../../../servicios/pqr/tratamientopqr.service';
import { AlertapqrService } from '../../../servicios/pqr/alertapqr.service';
import { EstadopqrService } from '../../../servicios/pqr/estadopqr.service';
import { UsuariosService } from '../../../servicios/usuarios/usuarios.service';
import { PerfilesService } from '../../../servicios/perfiles/perfiles.service';
import { RastreoService } from '../../../servicios/rastreo/rastreo.service';
import { ExportarCsvService } from '../../../servicios/exportar-csv/exportar-csv.service';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { EventosJqueryService } from '../../../servicios/eventos-jquery/eventos-jquery.service';
import { TecnicoasignadopqrService } from '../../../servicios/pqr/tecnicoasignadopqr.service';
import { AgendamientoAppService } from '../../../servicios/agendamiento-app/agendamiento-app.service';
//configuración del idioma de los datapicker
import { esLocale } from 'ngx-bootstrap/locale';
defineLocale('es', esLocale);
import { BsLocaleService               } from 'ngx-bootstrap/datepicker';
import { SlicePipe } from '@angular/common';

//Declaracion de variable global para usar jQuery
declare var $: any;

@Component({
  selector: 'app-modalpqr',
  templateUrl: './modalpqr.component.html',
  styleUrls: ['./modalpqr.component.css'],
  providers:[
    ExportarCsvService,
    TipopqrService,
    RastreoService,
    TecnicoasignadopqrService,
    AgendamientoAppService,
    PqrService,
    TercerosService,
    SucursalService,
    EquiposService,
    EquipoTerceroService,
    TiposervicioService,
    MediosoporteService,
    TratamientopqrService,
    AlertapqrService,
    EstadopqrService,
    UsuariosService
  ]
})

export class ModalpqrComponent implements OnInit {

  eventoclic : any = 0;
  listpermisos : any;
  mostrarpreloaderpri  : any = 1;
  listTecnicosDetallePqr          : any; //Listado de tecnicos segun detallepqrid
  mostrarDatos                    : boolean = false;
  noMostrarDatos                  : boolean = false;

  //Variables
  order: string     = 'info.name';
  reverse: boolean  = false;
  sortedCollection  : any[];
  mostrarpreloader  : any = 0;
  mensajesindatos   : any;
  formFiltros       : FormGroup;  //Fromulario
  formPqrs          : FormGroup;  //Fromulario
  modalRef          : BsModalRef; //Ventana modal
  mjs_error_excede_tamano = 'Se excede el tamaño permitido'; //Mensaje si se excede del tamaño permitido
  PATH              : any; //path de rutas
  textocliente      : string; //Argumento de busqueda del cliente
  clientes          : any[];  //Listado de clientes segun filtro
  listclientes_ini  : any[];  //Listado original de clientes inmutable
  mostrarCampos     : boolean = false;
  sucursales        : any; //listado de sucursales
  equipos           : any; //listado de equipos
  equiposterceros   : any[]; //listado de equipos por tercero
  dependencias      : any; //listado de dependencias
  texto             : string; //Argumento de busqueda de un registro
  listpqrs          = new Array(); //Listado de pqr segun filtro
  listpqrs_ini      = new Array(); //Listado original de pqr inmutable
  tiposervicios     : any; //listado de tipos de servicio
  tipopqr           : any; //listado de tipos de pqr
  mediosoporte      : any; //listado de medios de soporte
  accion            : string = '' //Accion para Crear o Editar
  coordinadores     = new Array(); //Listado de coordinadores
  listestadopqr     : any[]; //Listado segun filtro
  usuarios          : any[]; //Listado de usuarios
  listusuarios      : any; //Listado de usuarios
  disabled          : boolean = false;
  disabledEdit      : boolean = false; // validad si la pqr tiene moviminetos bloquea campos
  disabledEsAgenda  : boolean = false;   //bloquea los campos si la incidencia se creo desde agendamiento
  disabledsubmit    : boolean = false;
  disabledsucursal  : boolean = true;
  disabledequipo    :  boolean = true;
  close             : any;
  loaded            : boolean = false; //guarda la lectura de la archivo
  mensaje_registros = '';
  estadofechainc    : any; //Variable para permitir visualizar la fecha de la incidencia
  estadoactividadincidencia : any; //Variable para permitir visualizar las actividades de la incidencia
  fichatecnica      : any; //Variable para permitir visualizar las fichas tecnicas y campos operacion en incidencia,tratamiento , operacion
  validaticket      : any; //Variable para permitir visualizar campo numero de ticket en incidencia
  ismeridian        : boolean = true;
  tipomantenimiento : any;
  incconelineaconta : any;
  incconelineainven : any;
  servidorbdconta   : any;
  basedatosconta    : any;
  usuarioconta      : any;
  claveconta        : any;
  servidorbdinven   : any;
  basedatosinven    : any;
  usuarioinven      : any;
  claveinven        : any;
  verpreloader      : any = 1;
  tipoinventario    : any;
  validadorTicket   = 0; // validad si si el tichet ya se encuentra creado en la base de datos

  estadoincidencia  : any; //Variable para permitir visualizar estadoincidencia

  listactividadesFamilia  = new Array();
  totalActividadesFamilia =  new Array();

  //Obtener datos del usuario del storage
  usuarioid       : any = localStorage.getItem('usuarioid');
  cedulaUsuario   : any = localStorage.getItem('cedulaUsuario');
  idusuario       : any = localStorage.getItem('idusuario');
  idperfil        : any = localStorage.getItem('idperfil');
  tipousuario     : any = localStorage.getItem('tipousuario');

  cotizacion      : any = localStorage.getItem('cotizacion');
  version         : any = localStorage.getItem('version');
  terceroid       : any = localStorage.getItem('terceropqr');
  sucursalid      : any = localStorage.getItem('sucursalpqr');
  equipoterceroid : any = localStorage.getItem('equipoterceroid');
  estadocotiid    : any = localStorage.getItem('estadocotiid');

  itemequipoid    : any = localStorage.getItem('itemequipoid');
  operacion       : any = localStorage.getItem('operacion');
  operacionid     : any = localStorage.getItem('operacionid');


  //Objetos que contiene las variables para los campos de los formularios
  filtros = {
    clienteid : '', sucursalid : '', incidenciaid : '',  ticket : '', fechacreacion : '',
    fechacierre : '', prioridadid : '',  estadoid : '', servicioid : '', permiso_vertodaslasincidencias : '' ,
    equipoterceroid :'',tecnicoid :'',familiaid  : '' , marcaid : ''
  }


  //Objeto para PQR
  pqrs = {
    id              : '',
    pqrid           : '',
    ticket          : '',
    mediosoporteid  : '',
    terceroid       : '',
    sucursalid      : '',
    equipoterceroid : '',
    dependenciaid   : '',
    primernombre    : '',
    segundonombre   : '',
    primerapellido  : '',
    segundoapellido : '',
    direccion       : '',
    telefono        : '',
    asunto          : '',
    descripcion     : '',
    tipopqrid       : '',
    tiposervicioid  : '',
    nombre          : '',
    razonsocial     : '',
    fecha_pqr       : '',
    hora_pqr        : '',
    asignado_a      : '',
    coordinadorid   : '',
    archivo         : '',
    cambio_archivo  : '',
    archivopqrid    : '',
    cliente : {
      terceroid   : '',
      nombre      : '',
      razonsocial : ''
    },
    nombresucursal  : '',
    equipoid        : '',
    nombreequipo    : '',
    modelo          : '',
    originadopor    : '',
    serial          : '',
    actividadid     : this.totalActividadesFamilia,
    validadoperaciontiempo : '',
    operacionid     : ''
  }

  //Objeto para Detalle PQR
  detallepqr = {
    pqrid : '',
    fecha : '',
    estadopqrid : ''
  }

  //DATALIS: Declaracion de variables
  statesCliente         = new Array();
  statesTecnicoid       = new Array();
  statesSucursal        = new Array();
  statesEquipoFiltro          = new Array();
  statesPqr             = new Array();
  statesTicket          = new Array();
  statesFamilia         = new Array();
  statesMarca           = new Array();
  statesEstado          = new Array();
  statesTipoServicio    = new Array();
  selectedOptionCliente : any;
  selectedOptionPqr     : any;
  selectedOptionTicket  : any;

  //DATALIST: Para la ventana modal de creación de incidencia
  statesSucursales        = new Array();
  statesEquipos           = new Array();
  statesOperacion         = new Array();
  selectedOptionSucursal  : any;
  selectedOptionEquipo    : any;
  noResultSucursal        = false;
  noResultEquipo          = false;
  noResultOperacion       = false;


  //Constructor
  constructor(
    private _config         : ConfigService,
    private _valid          : ValidService,
    private _key            : KeyService,
    private route           : ActivatedRoute,
    private router          : Router,
    private http            : Http,
    private toastr          : ToastrService,
    private modalService    : BsModalService,
    private _pqr            : PqrService,
    private _tercero        : TercerosService,
    private _sucursal       : SucursalService,
    private _equipo         : EquiposService,
    private _equipoTercero  : EquipoTerceroService,
    private _tiposervicio   : TiposervicioService,
    private _tipopqr        : TipopqrService,
    private _mediosoporte   : MediosoporteService,
    private _tratamientopqr : TratamientopqrService,
    private _alertapqr      : AlertapqrService,
    private _estadopqr      : EstadopqrService,
    private orderPipe       : OrderPipe,
    private _usuarios       : UsuariosService,
    private _perfiles       : PerfilesService,
    private _rastreo        : RastreoService,
    private _exportarCsv    : ExportarCsvService,
    private esLocale        : BsLocaleService,
    private _tecnicoasignadopqr : TecnicoasignadopqrService,
    private _evtjq          : EventosJqueryService,
    private _agendamiento   : AgendamientoAppService
  ) {}


  ngOnInit()
  {
    //validar usuario ingresado
    this._usuarios.getUserIngresado();

    //Escucha los eventos al presionar la tecla Enter
    this._evtjq.eventoTeclaEnter();

    //Bloque que permite controlar los clics para llos modal de las horas
    document.addEventListener("click", function(e) {
      var  hours, minutes, seconds;
      var datehoraini = new Date($('#hora_pqr').val());
      hours = ("0" + datehoraini.getHours()).slice(-2);
      minutes = ("0" + datehoraini.getMinutes()).slice(-2);
      seconds = ("0" + datehoraini.getSeconds()).slice(-2);
      var fulltime = [hours, minutes, seconds].join(":");
      var display = $('#divhorainicial').css('display');
      if ( fulltime != 'aN:aN:aN' ) {
        $('#hora_pqr').val(fulltime);
      }
    }, false);

    this.esLocale.use('es');

    this.mostrarpreloader      = 1;

    this.statesCliente         = [];
    this.statesSucursal        = [];
    this.statesEquipoFiltro    = [];
    this.statesPqr             = [];
    this.statesTicket          = [];
    this.statesEstado          = [];
    this.statesTipoServicio    = [];

    this.mensaje_registros     = '1' ;

    //Se cargarn los permisos y dentro de esta función se carga el listado de incidencias
    this.getPermisos();

    //FILTROS INICIALES DATALIST:
    this.filtro_inicial_estadopqr();
    this.filtro_inicial_tiposervicio();

    this.createForm();

    //RASTREO
    let opcionEnviar = 'Ingreso Gestión de Incidencias';
    this._rastreo.setRastreo(opcionEnviar,'Gestión de Incidencias').subscribe((resp)=>{
    });

    //CARGA DE DATOS INICIALES
    this.obtenerTerceros('C');
    this.totalActividadesFamilia = [];
    this.obtenerDetallesPqr();
    this.obtenerTipoServicio();
    this.obtenerTipoPqr();
    this.obtenerMedioSoporte();
    this.obtenerDependencias();
    this.obtenerEstadopqr();
    this.obtenerUsuarios();
    this.obtenerUsuariosTipo('CO');
    this.paramCampos();
  }

  /**
   * Permite obtener los permisos y perfiles de usuario
   * JMM-2018-12-26
   */
  getPermisos()
  {
    this._perfiles.getPermisosUsuariosFull().subscribe((resp)=>{
      if (resp.data) {
        this.listpermisos = resp.data;
        this.mostrarpreloaderpri = 0;
      } else {
        this.mostrarpreloaderpri = 1;
      }

      //Cargar todos los registros de la incidencias
      this.obtenerIncidnciasFiltro(null,0);
      this.filtro_inicial_pqrs();
      this.getTecnicosTercero();
    });
  }
 /* ******************************************************************************* */
  //FILTROS INICIALES DATALIST TECNICOS TERCERO:
  //CAA-2019-02-22
  /* ******************************************************************************* */
  //FILTRO PQRS
  getTecnicosTercero(){
    this._tercero.getTecnicosTercero(this.listpermisos.especiales_vertodaslasincidencias).subscribe((resp)=>{
      let listtecnico = new Array();
          if (resp.data.length) {
            for (var i in resp.data ){
              if(resp.data[i].estadoid !='I'){
                listtecnico.push(resp.data[i]);
              }
            }

             //DATALIST CLIENTES
        //   //Se recorren los datos y se llena un array con la clave del identificador del cliente
          var parametroTecnicoid_aux = {};
          for (var i in listtecnico) {
            parametroTecnicoid_aux[listtecnico[i]['tecnicoid']] = listtecnico[i];
          }
          //Se recorre nuevamente el array con la clave del identificador del cliente y se eliminan los duplicados
          for (i in parametroTecnicoid_aux) {
            this.statesTecnicoid.push({
              'tecnicoid' : parametroTecnicoid_aux[i].tecnicoid,
              'nombre' : parametroTecnicoid_aux[i].nombre,
              'infofiltrotecnicoid' : parametroTecnicoid_aux[i].tecnicoid+' => '+parametroTecnicoid_aux[i].nombre
            });
          }
          }
    });

  }

    /**
   * Permite obtener la dependencia a la que pertenece un coordinador
   * JMM-2019-07-16
   */
  obtenerDependenciaCoordinador()
  {
    for(let i in this.coordinadores){
      if(this.formPqrs.value.coordinadorid == this.coordinadores[i].cedula){
        this.pqrs.dependenciaid = this.coordinadores[i].dependenciaid != ''
                                  && this.coordinadores[i].dependenciaid != 'null'
                                  && this.coordinadores[i].dependenciaid != null
                                  ? this.coordinadores[i].dependenciaid
                                  : ''; //mojinet777
      }
    }
    console.log('this.pqrs.dependenciaid',this.pqrs.dependenciaid);
  }// .obtenerDependenciaCoordinador()

    /**
   * Permite buscar los tecnicos que se encuentran dentro del historico del detalle de la pqr
   * CESAR ARIAS 21/03/2019
   */
  TecnicoAsignadoPqr(template:any, pqrid)
  {
    this._tecnicoasignadopqr.TecnicoAsignadoPqr(pqrid).subscribe((resp)=>{
      if (resp.data.length > 0) {
         this.mostrarDatos = true;
         this.noMostrarDatos = false;
         this.listTecnicosDetallePqr = resp.data;
      } else {
         this.mostrarDatos = false;
         this.noMostrarDatos = true;
      }
    });
  }// .TecnicoAsignadoPqr()

  /* ******************************************************************************* */
  //FILTROS INICIALES DATALIST:
  //JMM-2018-09-11
  /* ******************************************************************************* */
  //FILTRO PQRS
  filtro_inicial_pqrs()
  {
    let info = {
      'clienteid'        : 'null',
      'sucursalid'       : 'null',
      'incidenciaid'     : 'null',
      'equipoterceroid'  : 'null',
      'ticket'           : 'null',
      'familiaid'        : 'null',
      'marcaid'          : 'null',
      'fechacreacion'    : 'null',
      'fechacierre'      : 'null',
      'prioridadid'      : 'null',
      'estadoid'         : 'null',
      'servicioid'       : '',
      'tecnicoid'        : 'null',
      'permiso_vertodaslasincidencias'  : this.listpermisos.especiales_vertodaslasincidencias
    }
    this._pqr.getFilroPqr(info).subscribe((resp)=>{
      if (resp.data.length > 0)
      {
        //DATALIST CLIENTES
        //Se recorren los datos y se llena un array con la clave del identificador del cliente
        var parametroCliente_aux = {};
        for (var i in resp.data) {
            parametroCliente_aux[resp.data[i]['terceroid']] = resp.data[i];
        }
        //Se recorre nuevamente el array con la clave del identificador del cliente y se eliminan los duplicados
        for (i in parametroCliente_aux) {
          this.statesCliente.push({
            'terceroid' : parametroCliente_aux[i].terceroid,
            'nombre' : parametroCliente_aux[i].nombretercero,
            'infocliente' : parametroCliente_aux[i].terceroid+' => '+parametroCliente_aux[i].nombretercero
          });
        }

        //DATALIST SUCURSALES
        //Se recorren los datos y se llena un array con la clave del identificador de la sucursal
        var parametroSucursal_aux = {};
        for (var i in resp.data) {
            parametroSucursal_aux[resp.data[i]['sucursalid']] = resp.data[i];
        }
        //Se recorre nuevamente el array con la clave del identificador de la sucursal y se eliminan los duplicados
        for (i in parametroSucursal_aux) {
          this.statesSucursal.push({
            'sucursalid' : parametroSucursal_aux[i].sucursalid,
            'nombre' : parametroSucursal_aux[i].nombresucursal,
            'infosucursal' : parametroSucursal_aux[i].sucursalid+' => '+parametroSucursal_aux[i].nombresucursal
          });
        }

         //DATALIST SUCURSALES
        //Se recorren los datos y se llena un array con la clave del identificador de la sucursal
        var parametroEquipoFiltro_aux = {};
        for (var i in resp.data) {
            parametroEquipoFiltro_aux[resp.data[i]['equipoterceroid']] = resp.data[i];
        }
        //Se recorre nuevamente el array con la clave del identificador de la sucursal y se eliminan los duplicados
        for (i in parametroEquipoFiltro_aux) {
          this.statesEquipoFiltro.push({
            'itemequipoid'     : parametroEquipoFiltro_aux[i].itemequipoid,
            'equipoterceroid'  : parametroEquipoFiltro_aux[i].equipoterceroid,
            'nombreequipo'     : parametroEquipoFiltro_aux[i].nombreequipo,
            'infoequipofiltro' : parametroEquipoFiltro_aux[i].equipoterceroid +' => '+ parametroEquipoFiltro_aux[i].nombreequipo
            + '<em>' + '  ' +  parametroEquipoFiltro_aux[i].nombremarca + '</em>'
            + '  ' + (parametroEquipoFiltro_aux[i].serial ? ' Serial '  + parametroEquipoFiltro_aux[i].serial : '')
          });
        }

        //DATALIST INC
        for (var i in resp.data) {
          this.statesPqr.push({
            'pqrid' : resp.data[i].pqrid,
            'infopqr' : resp.data[i].pqrid
          });
        }

        //DATALIST TICKET
        //Se recorren los datos y se llena un array con la clave del identificador del ticket
        var parametroTicket_aux = {};
        for (var i in resp.data) {
          parametroTicket_aux[resp.data[i]['ticket']] = resp.data[i];
        }
        //Se recorre nuevamente el array con la clave del identificador del ticket y se eliminan los duplicados
        for (i in parametroTicket_aux) {
          this.statesTicket.push({
            'terceroid' : parametroTicket_aux[i].ticket,
            'infoticket' : parametroTicket_aux[i].ticket
          });
        }

               //DATALIST FAMILIA
        //Se recorren los datos y se llena un array con la clave del identificador del ticket
        var parametrofamilia_aux = {};
        for (var i in resp.data) {
          parametrofamilia_aux[resp.data[i]['familiaid']] = resp.data[i];  //cesar
        }
        //Se recorre nuevamente el array con la clave del identificador del ticket y se eliminan los duplicados
        for (i in parametrofamilia_aux) {
          this.statesFamilia.push({
            'familiaid' : parametrofamilia_aux[i].familiaid,
            'infofamilia' : parametrofamilia_aux[i].familiaid + ' => ' + parametrofamilia_aux[i].nombrefamilia
          });
        }

                       //DATALIST MARCA
        //Se recorren los datos y se llena un array con la clave del identificador del ticket
        var parametromarca_aux = {};
        for (var i in resp.data) {
          parametromarca_aux[resp.data[i]['marcaid']] = resp.data[i];  //cesar
        }
        //Se recorre nuevamente el array con la clave del identificador del ticket y se eliminan los duplicados
        for (i in parametromarca_aux) {
          this.statesMarca.push({
            'marcaid' : parametromarca_aux[i].marcaid,
            'infomarca' : parametromarca_aux[i].marcaid + ' => ' + parametromarca_aux[i].nombremarca
          });
        }
      }// .if (resp.data.length > 0)
    });
  }// .filtro_inicial_pqrs(tipousuario)

  //FILTRO ESTADO
  filtro_inicial_estadopqr()
  {
    this._estadopqr.getEstadopqr().subscribe((resp)=>{
      if (resp.data)
      {
        //DATALIST ESTADO
        for (var i in resp.data) {
          this.statesEstado.push({
            'id' : resp.data[i].id,
            'nombre' : resp.data[i].nombre
          });
        }
      }// .if (resp.data)
    });
  }// .filtro_inicial_estadopqr()

  //FILTRO TIPOSERVICO
  filtro_inicial_tiposervicio()
  {
    this._tiposervicio.getTipoServicio().subscribe((resp)=>{
      if (resp.data)
      {
        //DATALIST TIPO SERVICIO
        for (var i in resp.data) {
          this.statesTipoServicio.push({
            'id' : resp.data[i].id,
            'nombre' : resp.data[i].nombre
          });
        }
      }// .if (resp.data)
    });
  }// .filtro_inicial_tiposervicio()
  /* ******************************************************************************* */


  /**
   * Permite mostrar datos en el formulario ya sea para crear o editar dentro del modal
   * JMM-2018-07-11
   */
  cargarDatosModal(param)
  {
    this.validadorTicket   = 0;
    this.verpreloader = 1;
    this.textocliente = this.terceroid;
    this.buscarCliente(this.terceroid);

    if(param == 'crear')
    {
      this.disabledEdit = false;
      this.statesSucursales = [];
      this.statesCliente = [];
      this.statesEquipos = [];
      var hoy = new Date();
      var dia = ("0" + hoy.getDate()).slice(-2);
      var mes = ("0" + (hoy.getMonth()+1)).slice(-2);
      var anio= hoy.getFullYear();
      var hours = ("0" + hoy.getHours()).slice(-2);
      var minutes = ("0" + hoy.getMinutes()).slice(-2);
      var seconds = ("0" + hoy.getSeconds()).slice(-2);
      var fecha_actual = (" "+anio+"-"+mes+"-"+dia + ' ' + hours +':'+ minutes +':'+ seconds);

      //Bloque para sacar la hora automatica del sistema
      var  horas, minutos, segundos;
      var datehora = new Date();
      horas = ("0" + datehora.getHours()).slice(-2);
      minutos = ("0" + datehora.getMinutes()).slice(-2);
      segundos = ("0" + datehora.getSeconds()).slice(-2);
      var fulltime = [horas, minutos, segundos].join(":");

      this.disabled = false;
      this.pqrs.id = '';
      this.pqrs.ticket = '';
      this.pqrs.tipopqrid = '';
      this.pqrs.tiposervicioid = '';
      this.pqrs.mediosoporteid = '';
      this.pqrs.fecha_pqr = fecha_actual;
      this.pqrs.hora_pqr =  fulltime;
      this.pqrs.sucursalid = '';
      this.pqrs.asignado_a = '';
      this.pqrs.coordinadorid = '';
      this.pqrs.asunto = '';
      this.pqrs.descripcion = '';
      this.pqrs.archivo = '';
      this.pqrs.originadopor = '';
      this.pqrs.validadoperaciontiempo = '';
      this.pqrs.operacionid = '';
      this.accion = 'Registrar';
    }
  }// .cargarDatosModal(param)

  /**
   * Permite abrir un modal para seleccionar la hora
   * JMM-2019-02-27
   */
  abrirModal_Hora(eventoclic, param)
  {
    if (param == 'divhora_pqr') {
      this.eventoclic = (eventoclic == 1) ? 0 : 1;
      if (this.eventoclic == 0) {
        $('#divhora_pqr').show();
      } else {
        $('#divhora_pqr').hide();
      }
    }
  }// .abrirModal_Hora(eventoclic, param)

  /**
   * Permite obtener un registro especifico de una PQR
   * JMM-2018-07-11
   */
  obtenerRegistroPQR(id, param)
  {
    this.tipomantenimiento = '';
    this._pqr.editRegPqr(id).subscribe((resp)=>{
      this._agendamiento.listActividadesIncidencia(resp.data.pqrid).subscribe((respuesta)=>{
        this.listActividades(resp.data.itemequipoid,respuesta);
        this.operacionesTiempo(resp.data.itemequipoid, resp.data.operacionid,resp.data.operacion);
       });

      this.tipomantenimiento = resp.data.tipomantenimientoid;
      resp.data.tipomantenimientoid == 1 ? this.disabledEsAgenda = true  : this.disabledEsAgenda = false;
      resp.data.tipomantenimientoid == 1 ? this.disabled         = true  : this.disabled         = false;
      resp.data.tipomantenimientoid == 1 ? this.disabledsubmit   = true  : this.disabledsubmit   = false;

      //JMM-2019-06-11:
      //Bloque para desactivar o activar campos al editar una incidencia
      //valida que la incidencia no tenga procesos
      if(this.tipomantenimiento == 1){
        this._pqr.validarMoviPqr(id).subscribe((resp)=>{
          resp.data > 1 ? this.disabledEdit = true : this.disabledEdit = false;
        });
      }else{
        this._pqr.validarMoviPqr(id).subscribe((resp)=>{
          resp.data > 1 ? this.disabledEdit = false : this.disabledEdit = false;
        });
      }

      if (resp.data)
      {
        this.pqrs = resp.data;

        //Si el parametro es Duplicar, el numero de ticket es vacio
        if (param == 'duplicar') {
          this.pqrs.id = '';
          this.pqrs.ticket = '';
        }

        //Buscar datos del tercero
        var texto = this.pqrs.terceroid ? this.pqrs.terceroid.toLowerCase() : '';
        if (texto)
        {
          this.clientes = this.listclientes_ini.filter(
            item => item.terceroid.toLowerCase().indexOf(texto) !== -1
          );
        }// .if

        resp.data.operacionid ? (this.pqrs.validadoperaciontiempo = '1') :  (this.pqrs.validadoperaciontiempo = '0');
        this.pqrs.nombre = this.clientes[0] ? this.clientes[0].nombre : '';
        this.pqrs.razonsocial = this.clientes[0] ? this.clientes[0].razonsocial : '';
        this.pqrs.coordinadorid = this.pqrs.coordinadorid ? this.pqrs.coordinadorid : '';
        this.pqrs.equipoterceroid = this.pqrs.equipoterceroid ? this.pqrs.equipoterceroid : '';
        this.pqrs.fecha_pqr = resp.data.created_at;

        //Se extrae la hora de la fecha
        var arrayhoras = resp.data.created_at ? resp.data.created_at.split(' ') : '';
        this.pqrs.hora_pqr  = arrayhoras[1];

        if (id >= 0) //getEquipoTerceroSucursal
        {
          this.obtenerSucursalTercero_editar(this.pqrs.terceroid, this.pqrs.sucursalid);
          this.obtenerEquipoTerceroSucursal_editar(this.pqrs.sucursalid, this.pqrs.terceroid);
        }// .if
      }// .if

    });
  }// .obtenerRegistroPQR(id, param)

   /**
   * Permite habilitar los campos para actualizar los datos
   * CESAR ARIAS -2019-05-06
   */
  listActividades(itemequipoid,dataactividad){
    this.totalActividadesFamilia =[];
    this._equipoTercero.listActividadesItemequipo(itemequipoid).subscribe((resp) => {
      for (let i in resp.data) {
        let param = 0;
        for (let j in dataactividad.data) {
          if (resp.data[i].tipoactividadid == dataactividad.data[j].actividadid) {
            param = param + 1;
            this.totalActividadesFamilia.push(dataactividad.data[j]);
          }
        }
        if (param == 0) {
          this.totalActividadesFamilia.push(
            { actividadpqr: '0',
              actividadid: resp.data[i].tipoactividadid,
              pqrid: '',
              nombre : resp.data[i].nombre
            }
          )
        }
      }
    });
  }
  /**
   * Obtener listado de equipos de una sucursal asignada
   * JMM-2018-07-10
   */
  obtenerSucursalequipoAsignado(sucursal_id)
  {
    this._equipoTercero.listEquipoTerceroPorTerceroSucursal(sucursal_id).subscribe((resp)=>{
      console.log('dos',resp.data);
      if (resp.data.length > 0) {
        this.equiposterceros = resp.data;
      }
    });
  }// .obtenerSucursalequipoAsignado(sucursal_id)

  /**
   * Permite obtener el listado de usuarios y validar si es un administrador para
   * mostrar el listado general de todas las PQR
   * JMM-2018-07-11
   */
  obtenerUsuarios()
  {
    this.PATH = this._config.obtenerPath();
    let url = this.PATH+'/api/admin/usuarios';
    this.http.get(url, {headers:this._key.head()}).map(resp=>resp.json()).subscribe(data=>{
      if (data.data) {
        this.usuarios = data.data;
        for (let i in this.usuarios) {
          if (this.usuarios[i].usuarioid == this.usuarioid && this.usuarios[i].tipousuario == 'AD') {
            this.obtenerPqrs(0,null);
          }
        }
      }
    });
  }//Fin de obtenerUsuarios()

  /**
   * Función para optener el listado de PQR
   * JMM-2018-07-11
   */
  obtenerPqrs(filtrar,opcion)
  {
    //Inicialización de arreglos
    this.listpqrs = [];
    this.listpqrs_ini = [];

    this.mensaje_registros = '1';

    /* **************************************** */

   let info = {
        'clienteid'     : 'null',
        'sucursalid'    : 'null',
        'equipoterceroid' : 'null',
        'incidenciaid'  : 'null',
        'ticket'        : 'null',
        'familiaid'     : 'null',
        'marcaid'       : 'null',
        'fechacreacion' : 'null',
        'fechacierre'   : 'null',
        'prioridadid'   : 'null',
        'estadoid'      : 'null',
        'servicioid'    : '',
        'tecnicoid'     :'null',
        'permiso_vertodaslasincidencias'  : this.listpermisos.especiales_vertodaslasincidencias
      }

    if (filtrar == 1)
    {
      //valiadad cuando el boton de click para cargar todos los datos validad si el parametro es ==2  (obtenerPqrs(1,2))
      if (opcion ==2) {
        this.formFiltros.reset();
      }
      //Se realiza un split para sacar los identificadores:
      let clienteid_aux = this.formFiltros.value.clienteid ? this.formFiltros.value.clienteid.split("=>") : '';
      this.formFiltros.value.clienteid = clienteid_aux[0] ? clienteid_aux[0].trim() : '';
      let sucursalid_aux = this.formFiltros.value.sucursalid ? this.formFiltros.value.sucursalid.split("=>") : '';
      this.formFiltros.value.sucursalid = sucursalid_aux[0] ? sucursalid_aux[0].trim() : '';
      let incidenciaid_aux = this.formFiltros.value.incidenciaid ? this.formFiltros.value.incidenciaid.split("=>") : '';
      this.formFiltros.value.incidenciaid = incidenciaid_aux[0] ? incidenciaid_aux[0].trim() : '';
      let ticket_aux = this.formFiltros.value.ticket ? this.formFiltros.value.ticket.split("=>") : '';
      this.formFiltros.value.ticket = ticket_aux[0] ? ticket_aux[0].trim() : '';

      let tecnicoid_aux = this.formFiltros.value.tecnicoid ? this.formFiltros.value.tecnicoid.split("=>") : '';
      this.formFiltros.value.tecnicoid = tecnicoid_aux[0] ? tecnicoid_aux[0].trim() : '';

      let familiaid_aux = this.formFiltros.value.familiaid ? this.formFiltros.value.familiaid.split("=>") : '';
      this.formFiltros.value.familiaid = familiaid_aux[0] ? familiaid_aux[0].trim() : '';

      let marcaid_aux = this.formFiltros.value.marcaid ? this.formFiltros.value.marcaid.split("=>") : '';
      this.formFiltros.value.marcaid = marcaid_aux[0] ? marcaid_aux[0].trim() : '';

      let equipoFiltro = this.formFiltros.value.equipoterceroid ? this.formFiltros.value.equipoterceroid.split("=>") : '';
      this.formFiltros.value.equipoterceroid = equipoFiltro[0] ? equipoFiltro[0].trim() : '';

      this.formFiltros.value.permiso_vertodaslasincidencias = this.listpermisos.especiales_vertodaslasincidencias;


      if (this.formFiltros.value.clienteid != ''
      || this.formFiltros.value.sucursalid != ''
      || this.formFiltros.value.incidenciaid != ''
      || this.formFiltros.value.ticket != ''
      || this.formFiltros.value.equipoterceroid != '' && this.formFiltros.value.equipoterceroid != null
      || this.formFiltros.value.familiaid != '' && this.formFiltros.value.familiaid != null
      || this.formFiltros.value.marcaid != '' && this.formFiltros.value.marcaid != null
      || this.formFiltros.value.fechacreacion != '' && this.formFiltros.value.fechacreacion != null
      || this.formFiltros.value.fechacierre != '' && this.formFiltros.value.fechacierre != null
      || this.formFiltros.value.prioridadid != '' && this.formFiltros.value.prioridadid != null
      || this.formFiltros.value.estadoid != '' && this.formFiltros.value.estadoid != null
      || this.formFiltros.value.tecnicoid != '' && this.formFiltros.value.tecnicoid != null
      || this.formFiltros.value.servicioid != '' && this.formFiltros.value.servicioid != null)
      {

        this.obtenerIncidnciasFiltro(this.formFiltros.value , 1);
      }
      else
      {
        swal({
          title: 'Desea filtrar todos los registros?',
          text: "Si escoge la opción 'Si' el proceso puede tardar varios minutos.",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si',
          cancelButtonText: 'No'
        }).then((result) => {
          if (result.value)
          {
            this.listpqrs = [];
            this.listpqrs_ini = [];
            this.mensajesindatos = 0;
            this.mostrarpreloader = 0;
            this.obtenerIncidnciasFiltro(info,1);
          }// .if (result.value)
        });
      }
    }
    else if (filtrar == 0)
    {
      this.obtenerIncidnciasFiltro(info,1);
    }
  }// .obtenerPqrs()

  obtenerIncidnciasFiltro(info,opcion)
  {
    let data;
    let infoFiltro = {
      'clienteid'        : 'null',
      'sucursalid'       : 'null',
      'equipoterceroid'  : 'null',
      'incidenciaid'     : 'null',
      'ticket'           : 'null',
      'familiaid'        : 'null',
      'marcaid'          : 'null',
      'fechacreacion'    : 'null',
      'fechacierre'      : 'null',
      'prioridadid'      : 'null',
      'estadoid'         : 'null',
      'servicioid'       : '',
      'tecnicoid'        : 'null',
      'permiso_vertodaslasincidencias'  : this.listpermisos.especiales_vertodaslasincidencias
    }
    if (opcion == 1) {
       data = info;
    }else{
       data = infoFiltro;
    }

    this._pqr.getFilroPqr(data).subscribe((resp)=>{

      if (resp.data.length > 0)
      {
        this.listpqrs = [];
        this.listpqrs_ini = resp.data;

        if (this.usuarioid == 'prosof' || this.listpermisos.especiales_vertodaslasincidencias == true) {
          this.listpqrs = resp.data;
        }else if(opcion == 1){
          this.listpqrs = resp.data;
        }else if(opcion == 0){
          let contador = 0;
          for (let i in resp.data) {
            if (contador < 15) {
              this.listpqrs.push(resp.data[i]);
            }
            contador ++;
          }
        }

        if (this.listpqrs.length > 0) {
          this.mostrarpreloader = this.listpqrs.length;
          this.mensajesindatos = 0;
          this.sortedCollection = this.orderPipe.transform(this.listpqrs, '');
        } else {
          this.mostrarpreloader = 1;
          this.mensajesindatos = 1;
        }
      }// .if
      else
      {
        this.listpqrs = [];
        this.listpqrs_ini = [];
        this.mostrarpreloader = 1;
        this.mensajesindatos = 1;
      }// .else
    });
  }

  /**
   * Función para obtener el listado de notas del detalle de una PQR
   * JMM-2018-07-11
   */
  obtenerDetallesPqr()
  {
    this._tratamientopqr.getDetallePqr().subscribe((resp)=>{
      if (resp.data) {
        this.detallepqr = resp.data;
      }
    });
  }// .obtenerDetallesPqr(pqrid)

  /**
   * Función para optener el listado de Tipos de servicio
   * JMM-2018-07-11
   */
  obtenerTipoServicio()
  {
    this._tiposervicio.getTipoServicio().subscribe((resp)=>{
      if (resp.data) {
        this.tiposervicios = resp.data;
      }
    });
  }// .obtenerTipoServicio()


  /**
   * Función para optener el listado de Tipos de pqr
   * JMM-2018-07-11
   */
  obtenerTipoPqr()
  {
    this._tipopqr.getTipoPqr().subscribe((resp)=>{
      if (resp.data) {
        this.tipopqr = resp.data;
      }
    });
  }// .obtenerTipoPqr()

  /**
   * Función para optener el listado de Medio de soporte
   * JMM-2018-07-11
   */
  obtenerMedioSoporte()
  {
    this._mediosoporte.getMedioSoporte().subscribe((resp)=>{
      if (resp.data) {
        this.mediosoporte = resp.data;
      }
    });
  }// .obtenerMedioSoporte()

  /**
   * Permite obtener el listado de terceros
   * JMM-2018-07-10
   */
  obtenerTerceros(tipo)
  {
    if(tipo == 'C'){
      this._tercero.getListTerceros(tipo).subscribe((resp)=>{

        let listproveedir = new Array();

        for(let i in resp.data){
          if(resp.data[i].estadoid == 'A' || resp.data[i].estadoid ==null){
            listproveedir.push(resp.data[i]);
          };
        }

        this.clientes = listproveedir;
        this.listclientes_ini = JSON.parse(JSON.stringify(listproveedir));

        this.cargarDatosModal('crear'); //Cesar
      });
    }
  }// .obtenerTerceros(tipo)

  /**
   * Obtener el listado de usuarios segun el perfil
   * JMM-2018-07-10
   */
  obtenerUsuariosTipo(tipo)
  {
    this._usuarios.getListUsuariosPorTipo(tipo).subscribe((resp)=>{

      let listcoordinadores = new Array();
      for (let i in resp.data){
        if (resp.data[i].estadoid == 'A' || resp.data[i].estadoid ==null){
          listcoordinadores.push(resp.data[i]);
        };
      }
      this.coordinadores = listcoordinadores;
    });
  }// .obtenerUsuariosTipo(tipo)


  /** ************************************************************************************ */
  /** FILTROS PARA EL MODAL DE CREAR */
  /** ************************************************************************************ */

  /**
   * Permite obtener el listado de sucursales del tercero
   * JMM-2018-07-10
   */
  obtenerSucursalTercero_crear(tercero_id)
  {
    if(tercero_id != ''){

      this.disabledsucursal = true;

      this._sucursal.getSucursales(tercero_id).subscribe(respuesta=>{

        this.verpreloader = 0;
        this.statesSucursales = [];

        if(respuesta.data.length > 0){
          this.disabledsucursal = false;

          //DATALIST SUCURSALES EN MODAL
          //Se recorren los datos y se llena un array con la clave del identificador de la sucursal
          var parametroSucursal_aux = {};
          for(var i in respuesta.data){
              parametroSucursal_aux[respuesta.data[i]['sucursalid']] = respuesta.data[i];
          }
          //Se asigna un dato vacio como cabecera del array
          this.statesSucursales.push({'sucursalid' : '' });
          //Se recorre nuevamente el array con la clave del identificador de la sucursal y se eliminan los duplicados
          for(i in parametroSucursal_aux){
            this.statesSucursales.push({
              'sucursalid' : parametroSucursal_aux[i].sucursalid,
              'nombre' : parametroSucursal_aux[i].nombre,
              'infosucursal' : parametroSucursal_aux[i].sucursalid+' => '+parametroSucursal_aux[i].nombre
            });
          }

          console.log('sucursal: ', this.sucursalid);//mojinet777

          if(this.sucursalid != '' && this.sucursalid != 'null' && this.sucursalid != null && this.sucursalid != undefined){
            let opcionselec = this.statesSucursales.filter(data => data.sucursalid == this.sucursalid);
            this.statesSucursales[0] = (opcionselec.length > 0) ? opcionselec[0].infosucursal : '';
            this.getEquipoTerceroSucursal_filtro(this.sucursalid, null)
          }else{
            this.statesSucursales[0] = '';
            this.verpreloader = 0;
          }
        }
      });
    }
  }// .obtenerSucursalTercero_crear(tercero_id)

  /**
   * Obtener listado de equipos por tercero y por sucursal
   * JMM-2018-07-10
   */
  obtenerEquipoTerceroSucursal_crear(sucursalid)
  {
    this.disabledequipo = true;

    this._equipoTercero.listEquipoTerceroPorTerceroSucursal(sucursalid).subscribe((resp)=>{
      console.log('tres 3',resp.data);
      this.statesEquipos = [];

      if (resp.data.length > 0)
      {
        this.disabledequipo = false;

        //DATALIST
        var parametroEquipo_aux = {};
        for (var i in resp.data) {
          parametroEquipo_aux[resp.data[i]['equipoterceroid']] = resp.data[i];
        }
        //Se asigna un dato vacio como cabecera del array
        this.statesEquipos.push({'equipoterceroid' : '' });
        //Se recorre nuevamente el array con la clave del identificador de la sucursal y se eliminan los duplicados
        for (i in parametroEquipo_aux)
        {
          this.statesEquipos.push({
            'itemequipoid'    : parametroEquipo_aux[i].itemequipoid,
            'equipoterceroid' : parametroEquipo_aux[i].equipoterceroid,
            'nombre' : parametroEquipo_aux[i].nombreequipo,
            'infoequipo' : parametroEquipo_aux[i].equipoterceroid+' => '+parametroEquipo_aux[i].nombreequipo+' - '+parametroEquipo_aux[i].modelo + ' ' + (parametroEquipo_aux[i].nombremarca ? ' - <em>' + parametroEquipo_aux[i].nombremarca + '</em>' : '') + '- Seria ' + (parametroEquipo_aux[i].serial != null? parametroEquipo_aux[i].serial : '')
          });

          //Validacion para limpiar el campo cuando se hace el cambio de cliente
          if (this.disabledequipo == false) {
            this.statesEquipos[0] = '';
          }
        }// .for
      }// .if
      this.statesEquipos[0] = '';
      $("#crearEditarPqr").val('');
    });
  }// .obtenerEquipoTerceroSucursal_crear(sucursalid)

  /**
   * Permite obtener el listado de equipos del tercero
   * JMM-2018-07-10
   */
  obtenerEquiposTercero_crear(tercero_id)
  {
    if (tercero_id != '')
    {
      this.disabledequipo = true;

      this._equipoTercero.listEquipoTerceroPorTercero(tercero_id).subscribe(respuesta=>{

         this.statesEquipos = [];

         if (respuesta.data.length > 0)
         {
          this.mostrarpreloader = 0;
          this.disabledequipo = false;
           //DATALIST SUCURSALES EN MODAL
           var parametroEquipo_aux = {};
           for (var i in respuesta.data) {
             parametroEquipo_aux[respuesta.data[i]['equipoterceroid']] = respuesta.data[i];
           }
           //Se asigna un dato vacio como cabecera del array
           this.statesEquipos.push({'equipoterceroid' : '' });
           //Se recorre nuevamente el array con la clave del identificador de la sucursal y se eliminan los duplicados
           for (i in parametroEquipo_aux)
           {
             this.statesEquipos.push({
               'itemequipoid'    : parametroEquipo_aux[i].itemequipoid,
               'equipoterceroid' : parametroEquipo_aux[i].equipoterceroid,
               'nombre' : parametroEquipo_aux[i].nombreequipo,
               'infoequipo' : parametroEquipo_aux[i].equipoterceroid+' => '+parametroEquipo_aux[i].nombreequipo+' - '+parametroEquipo_aux[i].modelo
               + ' ' + (parametroEquipo_aux[i].nombremarca ? '-<em> ' + parametroEquipo_aux[i].nombremarca + '</em>' : '')
               + ' ' +(parametroEquipo_aux[i].serial != null ? ' - Serial ' + parametroEquipo_aux[i].serial : '')
             });

             //Validacion para limpiar el campo cuando se hace el cambio de cliente
             if (this.disabledequipo == false) {
               this.statesEquipos[0] = '';
             }
           }// .for
         }// .if
         this.statesEquipos[0] = '';
         $("#crearEditarPqr").val('');
         this.mostrarpreloader = 0;
      });
    }// .if
  }// .obtenerEquiposTercero_crear(tercero_id)

  /** ************************************************************************************ */


  /** ************************************************************************************ */
  /** FILTROS PARA EL MODAL DE EDITAR */
  /** ************************************************************************************ */

  /**
   * Permite obtener el listado de sucursales del tercero que se edita
   * JMM-2018-07-10
   */
  obtenerSucursalTercero_editar(tercero_id, sucursal_id)
  {
    if (tercero_id != '')
    {
      //Se inactiva el campo si llega el id del tercero y l acción es diferente a Duplicar
      this.disabled = (tercero_id != '' && this.accion != 'Duplicar') ? true : false;

      this._sucursal.getSucursales(tercero_id).subscribe(respuesta=>{

        //Se inicializa el array
        this.statesSucursales = [];
        if (respuesta.data.length > 0)
        {
          //DATALIST SUCURSALES EN MODAL
          //Se recorren los datos y se llena un array con la clave del identificador de la sucursal
          var parametroSucursal_aux = {};
          for (var i in respuesta.data) {
            parametroSucursal_aux[respuesta.data[i]['sucursalid']] = respuesta.data[i];
          }
          //Se asigna un dato vacio como cabecera del array
          this.statesSucursales.push({'sucursalid' : '' });
          //Se recorre nuevamente el array con la clave del identificador de la sucursal y se eliminan los duplicados
          for (i in parametroSucursal_aux)
          {
            this.statesSucursales.push({
              'sucursalid' : parametroSucursal_aux[i].sucursalid,
              'nombre' : parametroSucursal_aux[i].nombre,
              'infosucursal' : parametroSucursal_aux[i].sucursalid+' => '+parametroSucursal_aux[i].nombre
            });

            //Validacion para seleccionar la sucursal
            if (parametroSucursal_aux[i].sucursalid == sucursal_id) {
              this.statesSucursales[0] = parametroSucursal_aux[i].sucursalid+' => '+ parametroSucursal_aux[i].nombre;
            }
          }// .for

          if (this.sucursalid == null) {
            this.statesSucursales[0] = '';
            this.getEquipoTerceroSucursal(tercero_id);
          }
        }// .if
      });
    }// .if
  }// .obtenerSucursalTercero_editar(tercero_id, sucursal_id)


  /**
   * Obtener listado de equipos por tercero y por sucursal
   * JMM-2018-07-10
   */
  obtenerEquipoTerceroSucursal_editar(sucursalid, terceroid)
  {
    //SI TIENE SUCURSAL, SE CONSULTA EL EQUIPO POR SUCURSAL
    if (sucursalid != '' && sucursalid != null)
    {
      this._equipoTercero.listEquipoTerceroPorTerceroSucursal(sucursalid).subscribe((resp)=>{
        console.log('tres 4',resp.data);
        //Se inicializa el array
        this.statesEquipos = [];

        if (resp.data.length > 0)
        {
          //DATALIST SUCURSALES EN MODAL
          var parametroEquipo_aux = {};
          for (var i in resp.data) {
            parametroEquipo_aux[resp.data[i]['equipoterceroid']] = resp.data[i];
          }
          //Se asigna un dato vacio como cabecera del array
          this.statesEquipos.push({'equipoterceroid' : '' });
          //Se recorre nuevamente el array con la clave del identificador de la sucursal y se eliminan los duplicados
          for (i in parametroEquipo_aux)
          {
            this.statesEquipos.push({
              'itemequipoid'    : parametroEquipo_aux[i].itemequipoid,
              'equipoterceroid' : parametroEquipo_aux[i].equipoterceroid,
              'nombre' : parametroEquipo_aux[i].nombreequipo,
              'infoequipo' : parametroEquipo_aux[i].equipoterceroid+' => '+parametroEquipo_aux[i].nombreequipo+' - '+parametroEquipo_aux[i].modelo
               + ' '+ ( parametroEquipo_aux[i].nombremarca ? '- <em>' + parametroEquipo_aux[i].nombremarca + '</em>': '')
               + ' '+ (parametroEquipo_aux[i].serial != null ? '- Serial ' + parametroEquipo_aux[i].serial : '')
            });


            //Validacion para limpiar el campo cuando se hace el cambio de cliente
            // if (parametroEquipo_aux[i].equipoterceroid == this.pqrs.equipoterceroid) {
            //   this.statesEquipos[0] = this.pqrs.equipoterceroid+' => '+this.pqrs.nombreequipo+' - '+this.pqrs.modelo
            //   + ' '+(parametroEquipo_aux[i].serial != null? ' - Serial ' + parametroEquipo_aux[i].serial : '');
            // }
          }// .for
        }// .if
        $("#crearEditarPqr").val('');
        this.statesEquipos[0] = '';
      });
    }//.if
    // DE LO CONTRARIO SE CONSULTA EL EQUIPO POR CLIENTE DIRECTAMENTE
    else
    {

      this._equipoTercero.listEquipoTerceroPorTercero(terceroid).subscribe((resp)=>{

        //Se inicializa el array
        this.statesEquipos = [];

        if (resp.data.length > 0)
        {
          //DATALIST SUCURSALES EN MODAL
          var parametroEquipo_aux = {};
          for (var i in resp.data) {
            parametroEquipo_aux[resp.data[i]['equipoterceroid']] = resp.data[i];
          }

          //Se asigna un dato vacio como cabecera del array
          this.statesEquipos.push({'equipoterceroid' : '' });
          //Se recorre nuevamente el array con la clave del identificador de la sucursal y se eliminan los duplicados
          for (i in parametroEquipo_aux)
          {
            this.statesEquipos.push({
              'itemequipoid'    : parametroEquipo_aux[i].itemequipoid,
              'equipoterceroid' : parametroEquipo_aux[i].equipoterceroid,
              'nombre' : parametroEquipo_aux[i].nombreequipo,
              'infoequipo' : parametroEquipo_aux[i].equipoterceroid+' => '+parametroEquipo_aux[i].nombreequipo+' - '+parametroEquipo_aux[i].modelo
               + ' '+ (parametroEquipo_aux[i].serial != null? 'Serial ' + parametroEquipo_aux[i].serial : '')
            });

            //Validacion para limpiar el campo cuando se hace el cambio de cliente
            if (parametroEquipo_aux[i].equipoterceroid == this.pqrs.equipoterceroid) {
              this.statesEquipos[0] = this.pqrs.equipoterceroid+' => '+this.pqrs.nombreequipo+' - '+this.pqrs.modelo
              + ' '+(parametroEquipo_aux[i].serial != null ?  ' - Serial '+ parametroEquipo_aux[i].serial : '');
            }

          }// .for
        }// .if

      });
      $("#crearEditarPqr").val('');
      this.statesEquipos[0] = '';
    }//.else
  }// .obtenerEquipoTerceroSucursal_editar(sucursalid)

  /** ************************************************************************************ */


  /**
   * Obtener listado de equipos por tercero y por sucursal
   * JMM-2018-07-10
   */
  getEquipoTerceroSucursal_filtro(sucursalid, id)
  {
    //Se desactiva el campo
    this.disabledequipo = true;
    this.verpreloader = 0;

    this._equipoTercero.listEquipoTerceroPorTerceroSucursal(sucursalid).subscribe((resp)=>{
      console.log('1',resp.data);
      if (resp.data.length > 0)
      {
        //Se inicializa el arreglo
        this.statesEquipos = [];

        //Al cargar los datos se activa el campo nuevamente
        this.disabledequipo = false;
        this.equiposterceros = resp.data;

        //Validacion que aplica cuando se Edita la INC
        if (id != null) {
          this.statesEquipos[0] = this.pqrs.equipoterceroid+' => '+this.pqrs.nombreequipo+' - '+this.pqrs.modelo;
        }
        else
        {
          // var parametroEquipo_aux = {};
          // for (var i in resp.data) {
          //   parametroEquipo_aux[resp.data[i]['equipoid']] = resp.data[i];
          // }

          //Se asigna un dato vacio como cabecera del array
          this.statesEquipos.push({'equipoterceroid' : '' });
          //Se recorre nuevamente el array con la clave del identificador de la sucursal y se eliminan los duplicados
          for (var i in resp.data)
          {
            this.statesEquipos.push({
              'itemequipoid'    : resp.data[i].itemequipoid,
              'equipoterceroid' : resp.data[i].equipoterceroid,
              'nombre' : resp.data[i].nombreequipo,
              'infoequipo' : resp.data[i].equipoterceroid+' => '+resp.data[i].nombreequipo+' - '+resp.data[i].modelo
              + ' ' + (resp.data[i].nombremarca ? '- <em>' + resp.data[i].nombremarca + '</em>': '')
              +' '+ (resp.data[i].serial != null? '- Serial ' +  resp.data[i].serial : '')
            });


            //Validacion para limpiar el campo cuando se hace el cambio de cliente
            if (this.disabledequipo == false) {
              this.statesEquipos[0] = '';
            }
          }// .for   cesar

          if(this.equipoterceroid != '' && this.equipoterceroid != 'null' && this.equipoterceroid != null && this.equipoterceroid != undefined){
            console.log('equipoterceroid',this.equipoterceroid);
            console.log('statesEquipos',this.statesEquipos);
            let opcionselec = this.statesEquipos.filter(data => data.equipoterceroid == this.equipoterceroid);
            this.statesEquipos[0] = (opcionselec.length > 0) ? opcionselec[0].infoequipo : '';

            $(".equipo").attr('disabled',true);
            this.operacionesTiempo(this.itemequipoid,this.operacionid,this.operacion);
          }else{
            this.statesEquipos[0] = '';
            this.verpreloader = 0;
          }

        }// .else
      }// .if
      //this.statesEquipos[0] = '';
    });
  }// .getEquipoTerceroSucursal()

  /**
   * Obtener listado de equipos por tercero y por sucursal
   * JMM-2018-07-10
   */
  getEquipoTerceroSucursal(tercero_id)
  {
    //Se desactiva el campo
    this.disabledequipo= true;

    //Se inicializa el array
    this.statesEquipos = [];

    this._equipoTercero.listEquipoTerceroPorTercero(tercero_id).subscribe((resp)=>{

      if (resp.data)
      {
        //Al cargar los datos se activa nuevamente el campo
        this.disabledequipo = false;

        this.equiposterceros = resp.data;
        var cantidadRegistros = this.equiposterceros.length;
        var parametroEquipo_aux = {};

        for (var i in resp.data) {
          parametroEquipo_aux[resp.data[i]['equipoterceroid']] = resp.data[i];
        }

        //Se asigna un dato vacio como cabecera del array
        this.statesEquipos.push({'equipoterceroid' : '' });
        //Se recorre nuevamente el array con la clave del identificador de la sucursal y se eliminan los duplicados
        for (i in parametroEquipo_aux)
        {
          this.statesEquipos.push({
            'itemequipoid'    : parametroEquipo_aux[i].itemequipoid,
            'equipoterceroid' : parametroEquipo_aux[i].equipoterceroid,
            'nombre' : parametroEquipo_aux[i].nombreequipo,
            'modelo' : parametroEquipo_aux[i].modelo,
            'infoequipo' : parametroEquipo_aux[i].equipoterceroid+' => '+parametroEquipo_aux[i].nombreequipo+' - '+parametroEquipo_aux[i].modelo
            + ' ' + ( parametroEquipo_aux[i].nombremarca ? '- <em> ' + parametroEquipo_aux[i].nombremarca + '</em>': '')
            + ' '+ (parametroEquipo_aux[i].serial != null ? ' - Serial ' + parametroEquipo_aux[i].serial : '')
          });

          // if (parametroEquipo_aux[i].equipoterceroid == this.pqrs.equipoterceroid) {
          //   this.statesEquipos[0] = this.pqrs.equipoterceroid+' => '+this.pqrs.nombreequipo+' - '+this.pqrs.modelo
          //   + '  ' + ( parametroEquipo_aux[i].nombremarca ? '- <em>' + parametroEquipo_aux[i].nombremarca + '</em>': '')
          //   + ' ' +(parametroEquipo_aux[i].nombremarca != null ? ' - Serial ' +  parametroEquipo_aux[i].serial : '');
          // }
          this.statesEquipos[0] = '';
        }// .for
      }// .if
      this.statesEquipos[0] = '';
      $("#crearEditarPqr").val('');
    });
  }// .getEquipoTerceroSucursal()

  /**
   * Permite obtener el listado de dependencias
   * JMM-2018-07-10
   */
  obtenerDependencias()
  {
    this.PATH = this._config.obtenerPath();
    let url = this.PATH+'/api/admin/dependencias';
    this.http.get(url, {headers:this._key.head()}).map(resp=>resp.json()).subscribe(respuesta=>{
      if (respuesta.data) {
        this.dependencias  =respuesta.data;
      }
    });
  }//.obtenerDependencias()

  /**
   * Función para optener el listado de registros
   * JMM-2018-07-10
   */
  obtenerEstadopqr()
  {
    this._estadopqr.getEstadopqr().subscribe((resp)=>{
      if (resp.data) {
        this.listestadopqr = resp.data;
      }
    });
  }// .obtenerEstadopqr()

  /**
   * Permite buscar un registro de un cliente mediante un texto ingresado
   * JMM-2018-06-20
   */
  buscarCliente(terceroid)
  {
    this.verpreloader = 1;
    var texto = this.textocliente.toLowerCase();

    //Si llega texto busca por identificacion, nombre o razon social
    if (texto)
    {
      this.clientes = this.listclientes_ini.filter(
        item =>
        (item.terceroid ? item.terceroid.toLowerCase().indexOf(texto) !== -1 : '') ||
        (item.nombre ? item.nombre.toLowerCase().indexOf(texto) !== -1 : '')
      );
    }// .if
    //De lo contrario asigna un arreglo vacio
    else {
      this.clientes = [];
      this.pqrs.terceroid = this.clientes[0];
    }// .else

    //Si encuentra el registro retorna los datos
    if (typeof this.clientes !== 'undefined' && this.clientes.length > 0)
    {
      console.log('sucursal entro 1: ', this.sucursalid);//mojinet777
      this.mostrarCampos = false;
      this.pqrs.terceroid = this.clientes[0].terceroid;
      this.pqrs.nombre = this.clientes[0].nombre;
      this.pqrs.razonsocial = this.clientes[0].razonsocial;
      //OBTIENE LAS SUCURSALES
      if(this.sucursalid != '' && this.sucursalid != null){
        this.obtenerSucursalTercero_crear(this.pqrs.terceroid);
      }
      //OBTIENE LOS EQUIPOS
      this.obtenerEquiposTercero_crear(this.pqrs.terceroid);
      return this.pqrs.terceroid, this.pqrs.nombre, this.pqrs.razonsocial;
    }// .if
    //De lo contrario retorna datos vacios
    else
    {
      this.clientes = [];
      this.pqrs.terceroid = this.clientes[0];
      this.pqrs.nombre = this.clientes[0];
      this.pqrs.razonsocial = this.clientes[0];
      return this.pqrs.terceroid, this.pqrs.nombre, this.pqrs.razonsocial;
    }// .else
  }// .buscarCliente()

  /**
   * Envia la peticion a un servicio para actualizar o guardar el registro
   * JMM-2018-07-09
   */
  submit(idperfil, filtrar)
  {
    var selected = [];
    $("input[type=checkbox]").each(function(){
      if ($(this).is(":checked")){
         selected.push({
           'actividadid'      :   $(this).val(),
           'pqrid'            :   '',
           'esactividadpqr'  :    '1',
         });
      } else {
         selected.push({
           'actividadid'     :   $(this).val(),
           'pqrid'           :   '',
           'esactividadpqr' :    '0',
         });
      }
     }
    );

    this.formPqrs.value.operacionid != '' ? this.formPqrs.value.operacionid : (this.formPqrs.value.operacionid = '');
    this.formPqrs.value.actividadid = selected;
    this.disabledsubmit = true;
    //Se realiza un split para sacar los identificadores:
    let sucursalid_aux = this.formPqrs.value.sucursalid ? this.formPqrs.value.sucursalid.split("=>") : '';
    this.formPqrs.value.sucursalid = sucursalid_aux[0] ? sucursalid_aux[0].trim() : '';
    let equipoterceroid_aux = this.formPqrs.value.equipoterceroid ? this.formPqrs.value.equipoterceroid.split("=>") : '';
    this.formPqrs.value.equipoterceroid = equipoterceroid_aux[0] ? equipoterceroid_aux[0].trim() : '';
    let operacionid_aux = this.formPqrs.value.operacionid ? this.formPqrs.value.operacionid.split("=>") : '';
    this.formPqrs.value.operacionid = operacionid_aux[0] ? operacionid_aux[0].trim() : '';

    //Si validacion es erronea del formulario muestra mensaje
    if (!this.formPqrs.valid) {
      this._valid.touched(this.formPqrs);
      this.toastr.error('Campos obligatorios *', 'Error', { timeOut: 3000 });
      this.disabledsubmit = false;
    }
    //Si el formulario esta bien diligenciado
    else {
      //Validaciones para modificar o crear el registro
      if ($('#accionid').val() == 'Registrar') {
        this.enviarCrear();
      }
    }
  }// .submit()




     /**
   * validad ticketal momento de crear la incidencia
   * CESAR ARIAS -2019-08-27
   */

  validartickect(){
    console.log('validartickect',this.pqrs.ticket,this.pqrs.pqrid);
    this._pqr.validartickect(this.pqrs.ticket,this.pqrs.pqrid ? this.pqrs.pqrid : null).subscribe((resp)=>{
      if(resp.data == '1'){
        this.toastr.warning('Ya existe un registro con el mismo Número de ticket', '', { timeOut: 3000 });
        this.validadorTicket = 1;
      }else if(resp.data == '0'){
        this.validadorTicket = 0;
      }
    })
  }


  /**
   * Permite enviar la petición a un servicio para crear el registro
   * JMM-2018-06-14
   */
  enviarCrear()
  {
    var mySQLDate = '';
    var mySQLTime = '';

    this.formPqrs.value.estadopqrid = this.estadoincidencia ? this.estadoincidencia : '';

    //Bloque para sacar el formato de fecha
    if (this.formPqrs.value.fecha_pqr) {
      var  month, day, year;
      if (this.formPqrs.value.fecha_pqr.length == undefined) {
        var datefeha = new Date(this.formPqrs.value.fecha_pqr);
        day = datefeha.getDate().toString().length < 2 ? "0"+datefeha.getDate() : datefeha.getDate();  // ("0" + datefeha.getDate()).slice(-2);
        month = datefeha.getMonth().toString().length < 2 ? "0"+(datefeha.getMonth()+1) : (datefeha.getMonth()+1);  // ("0" + (datefeha.getMonth() + 1)).slice(-2);
        mySQLDate = [datefeha.getFullYear(), month, day].join("-");
      }
      else {
        var separador = " ";
        var auxiliar = this.formPqrs.value.fecha_pqr.split(separador);
        mySQLDate = auxiliar[1];
      }
    }

    //Bloque para sacar el formato de hora
    if ($('#hora_pqr').val()) {
      var  hours, minutes, seconds;
      var datehora = new Date(mySQLDate + ' ' + $('#hora_pqr').val());

      hours = ("0" + datehora.getHours()).slice(-2);
      minutes = ("0" + datehora.getMinutes()).slice(-2);
      seconds = ("0" + datehora.getSeconds()).slice(-2);

      if (hours == 'aN' || hours == 'aN' || hours == 'aN') {
        mySQLTime = mySQLDate + ' ' + $('#hora_pqr').val();
      } else {
        mySQLTime = [hours, minutes, seconds].join(":");
      }
    }

    $("#alertahora").html("");

    let fecha_creo  = mySQLDate ? mySQLDate  : '' ;
    let hora_creo   =  mySQLTime ? mySQLTime   : '' ;
    let created_at  = fecha_creo ? (fecha_creo + ' ' +hora_creo) : '' ;

    if (hora_creo != '' && fecha_creo == '') {
      this.toastr.error('El campo fecha es requerido el campo hora se encuentra  digitada *', 'Error', { timeOut: 3000 });
      this.disabledsubmit = false;
      let alertahora = '<span class="text-error" >' + this._config.errorRequired() + '</span>';
      $("#alertahora").html(alertahora);
    }
    else {
      //Datos de la PQR
      let dataPqr = {
        'ticket'               : this.formPqrs.value.ticket,
        'mediosoporteid'       : this.formPqrs.value.mediosoporteid,
        'terceroid'            : this.formPqrs.value.terceroid,
        'sucursalid'           : this.formPqrs.value.sucursalid,
        'equipoterceroid'      : this.formPqrs.value.equipoterceroid,
        'dependenciaid'        : this.pqrs.dependenciaid,
        'asunto'               : this.formPqrs.value.asunto,
        'descripcion'          : this.formPqrs.value.descripcion,
        'prioridadid'          : this.formPqrs.value.prioridadid,
        'tipopqrid'            : this.formPqrs.value.tipopqrid,
        'tiposervicioid'       : this.formPqrs.value.tiposervicioid,
        'coordinadorid'        : this.formPqrs.value.coordinadorid,
        'created_at'           : created_at,
        'usuario_creo'         : this.usuarioid,
        'originadopor'         : this.formPqrs.value.originadopor,
        //Datos del Detalle PQR
        'pqrid'                : this.formPqrs.value.pqrid,
        'estadopqrid'          : this.formPqrs.value.estadopqrid,
        'detalle'              : '',
        'estado_actualizado'   : 1,
        //Datos de la Alerta PQR
        'asignado_a'           : this.formPqrs.value.coordinadorid,
        'idperfil'             :  this.idperfil == 'C' ? this.idperfil :  null,
        'tipo'                 : '1',
        'estado'               : 'A',
        //Datos de la archivo PQR
        'archivo'              : this.formPqrs.value.archivo,
        'actividadid'          : this.formPqrs.value.actividadid,
        'operacionid'          : this.formPqrs.value.operacionid,
        'validadticket'        : this.validaticket,
        //Datos si tiene conexión en linea
        'incconelineaconta'    : this.incconelineaconta,
        'incconelineainven'    : this.incconelineainven,
        'servidorbdconta'      : this.servidorbdconta,
        'basedatosconta'       : this.basedatosconta,
        'usuarioconta'         : this.usuarioconta,
        'claveconta'           : this.claveconta,
        'servidorbdinven'      : this.servidorbdinven,
        'basedatosinven'       : this.basedatosinven,
        'usuarioinven'         : this.usuarioinven,
        'claveinven'           : this.claveinven,
        'tipoinventario'       : this.tipoinventario,
        //Datos de la incidencia
        'cotizacion'           : this.cotizacion,
        'version'              : this.version,
        'estadocotiid'         : this.estadocotiid
      }

      //GUARDA TRANSACCIÓN  DATOS DE LA PQR
      this._pqr.setPqr(dataPqr).subscribe((resp)=>{

        if (resp.error) {
          if (resp.data.errorInfo) {
            this.toastr.error(resp.data.errorInfo[2], 'Error', { timeOut: 3000 });
          }else{
            this.toastr.error(resp.message, 'Error', { timeOut: 3000 });
          }
          this.disabledsubmit = false;
        }else if (resp.data =='E'){
          this.toastr.warning(resp.message, '', { timeOut: 3000 });
          this.disabledsubmit = false;
        }else{
          this.toastr.success(resp.message, '', { timeOut: 3000 });
          this.disabledsubmit = false;
          this.formPqrs.reset();
          //Se remueve el modal
          $('.modal, .modal-backdrop').fadeOut();
          //Se habilita el scroll del navegador
          document.getElementsByTagName("html")[0].style.overflow="auto";
          localStorage.removeItem('itemequipoid');
          localStorage.removeItem('operacion');
          localStorage.removeItem('operacionid');
          localStorage.removeItem('terceropqr');
          localStorage.removeItem('sucursalpqr');
          localStorage.removeItem('equipoterceroid');

          if(this.equipoterceroid > 0){

            this.router.navigate(['/main/pqr/tratamiento-pqr/'+resp.data], { replaceUrl: true });
          }else{
            this.router.navigate(['main/enrutamientos/enrutamiento/'+'cotizacion'], { replaceUrl: true });
          }
        }
      });
    }
  }// .enviarCrear()


  /**
   * Se encarga de cargar la archivo
   * JMM-2018-06-27
   */
  cargarImagen(e)
  {
    //Se recogen los datos de la archivo
    var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    // var pattern = /image-*/;
    var reader = new FileReader();
    // //Si el formato de la archivo (.jpg, .png, .gif) es invalido muestra mensaje
    // if (!file.type.match(pattern)) {
    //   this.toastr.error('Formato de archivo invalido *', 'Error', { timeOut: 3000 });
    //   return;
    // }
    this.loaded = false; //renderizar la archivo para mostrarla en vista previa
    reader.onload = this._renderizarImagen.bind(this); //llamado de la funcion de renderización
    reader.readAsDataURL(file);
  }// .cargarImagen(e)

  /**
   * Se encarga de renderizar la archivo en tiempo real
   * para visualizarla en vista previa
   * JMM-2018-06-27
   */
  _renderizarImagen(e)
  {
    var reader = e.target;
    this.pqrs.archivo = reader.result; //guarda la renderización de la archivo
    this.pqrs.cambio_archivo = '1'; //guarda un valor para saber si la archivo se subio desde la vista
    this.loaded = true;
  }// ._renderizarImagen(e)


  /**
   * DATALIST: Envia los parametros
   * JMM-2018-09-10
   */
  onSelectCliente(event: TypeaheadMatch): void { this.selectedOptionCliente = event.item.terceroid; }
  onSelectPqr(event: TypeaheadMatch): void { this.selectedOptionPqr= event.item.pqrid; }
  onSelectTicket(event: TypeaheadMatch): void { this.selectedOptionTicket= event.item.pqrid; }
  onSelectFamiliaFiltro(event: TypeaheadMatch): void { this.selectedOptionTicket= event.item.familiaid; }
  onSelectmarcaFiltro(event: TypeaheadMatch): void { this.selectedOptionTicket= event.item.marcaid; }
  onSelectSucursal(event: TypeaheadMatch): void { this.selectedOptionSucursal= event.item.sucursalid; }

  onSelectEquipoFiltro(event: TypeaheadMatch): void {
    let data = ($('#filtroEquipo').val().replace('<em>','').replace('</em>','')); // elimina etiquetas de la cadena de texto
    $('#filtroEquipo').val(data);
   }

  onSelectEquipo(event: TypeaheadMatch): void {
     this.selectedOptionEquipo= event.item.equipoid;
     let data = ($('#crearEditarPqr').val().replace('<em>','').replace('</em>','')); // elimina etiquetas de la cadena de texto
     $('#crearEditarPqr').val(data);
     this.listActividadesItemequipo(event.item.itemequipoid);
     this.operacionesTiempo(event.item.itemequipoid,null,null);
    }

  onSelectOperacion(event: TypeaheadMatch): void { this.pqrs.operacionid= event.item.operacionid;}

  typeaheadNoResultsSucursal(event: boolean): void { this.noResultSucursal = event; }
  typeaheadNoResultsEquipo(event: boolean): void { this.noResultEquipo = event; }

  typeaheadNoResultsOperacion(event: boolean): void { this.noResultOperacion = event; }

   /**
   * lista todas las activiadades por defaul del equipo y los coloca chekeados
   * CESAR ARIAS -2019-05-06
   */
  listActividadesItemequipo(itemequipoid){  //cesar1
    this.totalActividadesFamilia = [];
    this._equipoTercero.listActividadesItemequipo(itemequipoid).subscribe((resp) => {
      for (let i in resp.data){
        this.totalActividadesFamilia.push(
          { actividadpqr: '1',
            actividadid: resp.data[i].tipoactividadid,
            pqrid: '',
            nombre : resp.data[i].nombre
          }

        )
      }
    });
  }

   /**
   * olista todas las operacionesde tiempo del equipo inventariado
   * CESAR ARIAS -2019-05-07
   */
  operacionesTiempo(itemequipoid,operaionid,operacion){  //cesar1
    this._pqr.operacionesTiempo(itemequipoid).subscribe((resp) => {
      this.statesOperacion = [];
       //DATALIST OPERACIONES DE TIEMPO
       var parametroOperacioniempo_aux = {};
       for (var i in resp.data) {
         parametroOperacioniempo_aux[resp.data[i]['operacionid']] = resp.data[i];
       }

       //Se asigna un dato vacio como cabecera del array
       this.statesOperacion.push({'operacionid' : '' });
       //Se recorre nuevamente el array con la clave del identificador de la operacion y se eliminan los duplicados
       for (i in parametroOperacioniempo_aux)
       {
         this.statesOperacion.push({
           'itemequipoid' : parametroOperacioniempo_aux[i].operacionid,
           'nombre'       : parametroOperacioniempo_aux[i].operacion,
           'infooperacion'   : parametroOperacioniempo_aux[i].operacionid+' => '+parametroOperacioniempo_aux[i].operacion
         });
        }
        if (operaionid){
          this.statesOperacion[0] = operaionid + ' => '+ operacion;
        }else{
          this.statesOperacion[0] = '';
        }
    });
  }

  /**
   * Obtener parametros de la tabla montaje para viualizar campos
   * JMM-2018-10-04
   */
  paramCampos()
  {
    //Obtener parametros
    this._pqr.paramCampos().subscribe((resp)=>{
      if(resp.data){
        this.estadofechainc             = resp.data.estadofechainc;
        this.estadoactividadincidencia  = resp.data.actividadincidencia;
        this.fichatecnica               = resp.data.fichatecnica;
        this.validaticket               = resp.data.validaticket;
        this.incconelineaconta          = resp.data.incconelineaconta;
        this.incconelineainven          = resp.data.incconelineainven;
        this.servidorbdconta            = resp.data.servidorbdconta;
        this.basedatosconta             = resp.data.basedatosconta;
        this.usuarioconta               = resp.data.usuarioconta;
        this.claveconta                 = resp.data.claveconta;
        this.servidorbdinven            = resp.data.servidorbdinven;
        this.basedatosinven             = resp.data.basedatosinven;
        this.usuarioinven               = resp.data.usuarioinven;
        this.claveinven                 = resp.data.claveinven;
        this.tipoinventario             = resp.data.tipoinventario;
        this.estadoincidencia           = resp.data.estadoincidencia;
      }
    });
  }// .paramCampos()


  /**
   * Permite cerrar un modal
   * JMM-2019-07-05
   */
  cerrarModalPqr()
  {
    //Se remueven los parametros del estorage
    //localStorage.removeItem('paramusuarioid');
    //localStorage.removeItem('paramperfilid');

    //Se remueve el modal
    $('.modal, .modal-backdrop').fadeOut();
    $('.modal').remove();

    //Se habilita el scroll del navegador
    document.getElementsByTagName("html")[0].style.overflow="auto";
  }// .cerrarmodal()

  /**
   * Permite validar el formulario
   * JMM-2018-07-09
   */
  createForm()
  {
    //validad parametro de la tabla montaje si  requiere ticket o no
    let validador;
    if (this.validaticket == '1') {
      validador = [Validators.required, Validators.maxLength(15),Validators.pattern("[a-zA-Z0-9_]+")];
    }

    //Formulario para los filtros
    this.formFiltros = new FormGroup({
      'clienteid'          : new FormControl(this.filtros.clienteid),
      'sucursalid'         : new FormControl(this.filtros.sucursalid),
      'incidenciaid'       : new FormControl(this.filtros.incidenciaid),
      'ticket'             : new FormControl(this.filtros.ticket),
      'fechacreacion'      : new FormControl(this.filtros.fechacreacion),
      'fechacierre'        : new FormControl(this.filtros.fechacierre),
      'prioridadid'        : new FormControl(this.filtros.prioridadid),
      'estadoid'           : new FormControl(this.filtros.estadoid),
      'servicioid'         : new FormControl(this.filtros.servicioid),
      'permiso_vertodaslasincidencias'  : new FormControl(this.filtros.permiso_vertodaslasincidencias),
      'equipoterceroid'    : new FormControl(this.filtros.equipoterceroid),
      'tecnicoid'          : new FormControl(this.filtros.tecnicoid),
      'familiaid'          : new FormControl(this.filtros.familiaid),
      'marcaid'            : new FormControl(this.filtros.marcaid),
    });

    //Formulario para registrar o editar los datos
    this.formPqrs = new FormGroup({
      //DATOS PARA LA TABLA HEADPQR
      'id'              : new FormControl(this.pqrs.id),
      'ticket'          : new FormControl(this.pqrs.ticket, validador),
      'mediosoporteid'  : new FormControl(this.pqrs.mediosoporteid),
      'terceroid'       : new FormControl(this.pqrs.terceroid, [Validators.required]),
      'sucursalid'      : new FormControl(this.pqrs.sucursalid),
      'equipoterceroid' : new FormControl(this.pqrs.equipoterceroid, [Validators.required]),
      'dependenciaid'   : new FormControl(this.pqrs.dependenciaid),
      'asunto'          : new FormControl(this.pqrs.asunto, [Validators.required, Validators.maxLength(100)]),
      'originadopor'    : new FormControl(this.pqrs.originadopor, [Validators.maxLength(100)]),
      'descripcion'     : new FormControl(this.pqrs.descripcion),
      'tipopqrid'       : new FormControl(this.pqrs.tipopqrid, [Validators.required]),
      'tiposervicioid'  : new FormControl(this.pqrs.tiposervicioid, [Validators.required]),
      'textocliente'    : new FormControl(this.textocliente),
      'nombre'          : new FormControl(this.pqrs.nombre),
      'razonsocial'     : new FormControl(this.pqrs.razonsocial),
      'fecha_pqr'       : new FormControl(this.pqrs.fecha_pqr),
      'hora_pqr'       : new FormControl(this.pqrs.hora_pqr),
      //DATOS PARA LA TABLA DETALLE PQR
      'pqrid'           : new FormControl(this.detallepqr.pqrid),
      'fecha'           : new FormControl(this.detallepqr.fecha),
      'estadopqrid'     : new FormControl(this.detallepqr.estadopqrid),
      //DATOS PARA LA ALERTA PQR
      'asignado_a'      : new FormControl(this.pqrs.asignado_a),
      //DATOS PARA SUBIR EL ARCHIVO
      'archivo'         : new FormControl(this.pqrs.archivo),
      'cambio_archivo'  : new FormControl(this.pqrs.cambio_archivo),
      'archivopqrid'    : new FormControl(this.pqrs.archivopqrid),
      'actividadid'     : new FormControl(this.pqrs.actividadid),
      'coordinadorid'   : new FormControl(this.pqrs.coordinadorid, [Validators.required]),
      'validadoperaciontiempo' : new FormControl(this.pqrs.actividadid),
      'operacionid'     : new FormControl(this.pqrs.actividadid),
    });
  }// .createForm()

}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/main/pqr/modalpqr/modalpqr.component.ts